export const getNumbers = (str: string): string => {
  // removes everything but numbers
  return str?.replace(/[^0-9.]/g, '');
};

export const getLetters = (str: string): string => {
  // removes everything but letters
  return str?.replace(/[^A-Za-z]/g, '');
};
export const getNumbersWithDecimal = (str: string): string => {
  return getNumbers(str).replace(/(\..*)\./g, '.');
};

export const validateStringIsOnlyLetters = (value: string): boolean => {
  if (/[/;'!@#$%^&*(),.?":+\-_={}[\]{}|<>\d`~\\]+/g.test(value)) {
    return false;
  }
  return true;
};

export function setNumberWithCommas(x: number | undefined): string {
  if (!x && x !== 0) {
    return '';
  }
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
